import { render, staticRenderFns } from "./capitalAccountInitList.vue?vue&type=template&id=23b5a843"
import script from "./capitalAccountInitList.vue?vue&type=script&lang=js"
export * from "./capitalAccountInitList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports